import React from 'react';
import styles from './providerModals.module.scss';
import classnames from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import ActivityTabList from 'v2/common/DRM/ActivityTab/ActivityTabList';
import { ActivityAssociation } from 'v2/models';

export interface InteractionsActivityListProps {
  relatedObjectId: number;
  defaultAssociations: ActivityAssociation[];
  show: boolean;
  animation: boolean;
  onToggleForm: () => void;
  onEntered: () => void;
  onHide: () => void;
}

const InteractionsActivityList = ({
  relatedObjectId,
  defaultAssociations,
  onToggleForm,
  show,
  onEntered,
  onHide,
  animation,
}: InteractionsActivityListProps) => {
  return (
    <Modal
      size="lg"
      centered
      show={show}
      onEntered={onEntered}
      onHide={onHide}
      animation={animation}
      scrollable
    >
      <Modal.Header className="bg-light py-4">
        <Modal.Title>Interactions</Modal.Title>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Header>
      <Modal.Body
        className={classnames(styles.interactionsBody, 'text-light4')}
      >
        <div className="ml-5 mr-5 mb-5">
          <ActivityTabList
            listDescriptor={{
              relatedTable: 'DataVendor',
              relatedObjectId: relatedObjectId,
              system_generated: false,
            }}
            defaultAssociations={defaultAssociations}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={() => onToggleForm()} className="btn btn-primary">
          Add Activity
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InteractionsActivityList;
